/* eslint-disable @nx/enforce-module-boundaries */
import {
  Button,
  HStack,
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalBody,
  ModalCloseButton,
} from "@mybridge/ui";

export const ArticleDeleteModal = ({
  isOpen,
  onClose,
  onConfirm,
  title = "Delete Article",
  message1 = "The article will be permanently deleted.",
}) => {
  return (
    <Modal isOpen={isOpen} onClose={onClose} isCentered size={['sm', 'lg']}>
      <ModalOverlay />
      <ModalContent>
        <ModalHeader color="#3D5A80" fontSize="18px">
          {title}
        </ModalHeader>
        <ModalCloseButton />
        <ModalBody pb={1} width="80%" fontSize="16px">
          {message1}
        </ModalBody>
        <HStack my="25px" px={4} justifyContent="flex-end">
          <Button
            bg="#E4E6EB"
            color="#000"
            width="30%"
            borderRadius="70px"
            onClick={onClose}
          >
            Cancel
          </Button>
          <Button
            bg="#e94242ff"
            width="30%"
            color="#fff"
            borderRadius="70px"
            onClick={onConfirm}
            _hover={{ bg: "#e94242ff" }}
          >
            Delete
          </Button>
        </HStack>
      </ModalContent>
    </Modal>
  );
};
